export enum InputType {
    clipboard = "clipboard",
    oversize = "oversize",
    default = "default"
}